import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersAutoloadFirstTicketInList = createBasicSelector(
  state => selectBooleanPreferenceByName(state, 'autoload_first_ticket_in_list')
)
